export const MockConfigData = {};
